import React from 'react';

function BlockUsedFrom({ pomAndSizeList }) {
	return (
		<>
			{pomAndSizeList &&
				pomAndSizeList.measurementCopyFromResponse &&
				pomAndSizeList.measurementCopyFromResponse.blockDetailsResponse && (
					<p className="pl-4">
						<span className="regular-12 gray_dark-01 weight-400">Block used from: </span>
						<span
							className="text-underline regular-12 cursor-pointer"
							onClick={() =>
								window.open(
									`/collections/list?openDesign=true&productId=${pomAndSizeList.measurementCopyFromResponse.id}`,
									'_blank'
								)
							}
						>
							{pomAndSizeList?.measurementCopyFromResponse?.blockDetailsResponse?.blockTitle ||
								''}{' '}
							{pomAndSizeList?.measurementCopyFromResponse?.blockDetailsResponse?.blockTitle &&
								pomAndSizeList?.measurementCopyFromResponse?.blockDetailsResponse
									?.productRefNo &&
								', '}{' '}
							{pomAndSizeList?.measurementCopyFromResponse?.blockDetailsResponse
								?.productRefNo || ''}
						</span>
					</p>
				)}
		</>
	);
}

export default BlockUsedFrom;
